export default __webpack_public_path__ + "static/media/es.dec6ea19.svg";